import Toast, { Events as ToastEvents } from '~/components/Toast'
import Vue from 'vue'

export const Events = {
	Create: 'create',
}

const target = new EventTarget()

function generateToast(heading, text, bgcolor, textcolor, options) {
	target.dispatchEvent(new CustomEvent(Events.Create, {
		detail: {
			heading,
			text,
			bgcolor,
			textcolor,
			key: Date.now(),
			...options,
		},
	}))
}

function createNotificationRoot() {
	const root = new Vue(ToastsRoot)

	root.$mount()
	document.body.appendChild(root.$el)
}

document.addEventListener('DOMContentLoaded', createNotificationRoot, { once: true })

const ToastsRoot = {
	name: 'ToastRoot',
	data: () => ({ toasts: [] }),
	created() {
		this.$options.map = new Map()
	},
	methods: {
		removeToast(idx) {
			const [toast] = this.toasts.splice(idx, 1)
			this.$options.map.delete(toast.key)
		}
	},
	mounted() {
		const handleCreate = ({ detail }) => {
			const toast = { ...detail }

			if (this.$options.map.has(toast.key)) {
				const savedToast = this.$options.map.get(toast.key)

				Object.entries(toast).forEach(([key, value]) => {
					if (key === 'key') return

					this.$set(savedToast, key, value)
				})
			}
			else {
				this.toasts.push(toast)
				this.$options.map.set(toast.key, toast)
			}
		}

		target.addEventListener(Events.Create, handleCreate)
	},
	render(h) {
		return (
			<div class="position-fixed p-3 mt-5" style="z-index: 1050; right: 0; top: 0;">
				{ this.toasts.map(({ key, ...options }, idx) => (
					<Toast
						key={ key }
						{ ...{
							props: options,
							on: {
								[ToastEvents.Closed]: () => this.removeToast(idx)
							},
						}}
					/>
				)) }
			</div>
		)
	}
}

export const error = (options) => generateToast(null, null, null, null, {
	...options,
	bgcolor: '#FF0037',
	textcolor: 'white',
})

export const info = (options) => generateToast(null, null, null, null, {
	...options,
	bgcolor: '#009996',
	textcolor: 'white',
})

export const success = (options) => generateToast(null, null, null, null, {
	...options,
	bgcolor: '#6EC67B',
	textcolor: 'black',
})

export default generateToast;
